/**
 * Browser downloads of documents the Console builds itself (a sample statement, a generated
 * report).
 *
 * The prototype's bank instruction for pending redemptions lived here too; it went with the
 * prototype's order list (IP-89). A redemption's payout file is the Core's own now - generated,
 * stored and fingerprinted by PAYOUT_GENERATE (IP-63) - not something the browser assembles.
 */

/**
 * Save a file the server has stored and linked (a presigned GET, attachment): the browser fetches it from the link,
 * so nothing passes through the page and a hash route is never left.
 */
export const downloadLink = (url, fileName) => {
    const link = document.createElement('a');
    link.href = url;
    link.download = fileName;
    link.rel = 'noopener';
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
};

/** Trigger a browser download of the generated document. */
export const downloadCsv = (filename, contents) => {
    const blob = new Blob([contents], { type: 'text/csv;charset=utf-8;' });
    const url = URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.download = filename;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    URL.revokeObjectURL(url);
};
